import { TChangePasswordReq } from "@sharedTypes/req.type";
import { TChangePasswordRes } from "@sharedTypes/res.type";
import missingParametersError from "api/Error";
import axios from "axios";

export async function ChangePassword(oldPassword: string, newPassword: string) {
  const apiUrl = "/auth/changepassword";

  const body: TChangePasswordReq = {
    oldPassword,
    newPassword,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TChangePasswordRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });

  return data;
}
